import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, EffectCoverflow } from "swiper/core";

import ProductCard from "../../Helpers/ProductCard";
import ArrowIcon from "@/components/icons/ArrowIcon";

SwiperCore.use([EffectCoverflow, Autoplay, Pagination]);

const FrequentlyBoughtTogetherSwiper = ({
  frequentlyBoughtTogetherProducts,
  locale,
  t,
}) => {
  const [swiper, setSwiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  // The slider opens on a middle slide, so the edge flags are already false
  // before the first swipe — seed them from the instance instead of assuming.
  const syncEdges = (instance) => {
    setIsBeginning(instance?.isBeginning);
    setIsEnd(instance?.isEnd);
  };

  return frequentlyBoughtTogetherProducts?.length > 0 ? (
    <>
      <h3 className="mt-2 text-lg font-semibold px-4">
        {t("Frequently Bought Together")}
      </h3>
      <div className="relative mx-auto py-5 bg-white px-2">
        <Swiper
          onInit={(instance) => {
            setSwiper(instance);
            syncEdges(instance);
          }}
          key={locale}
          dir={locale === "ar" ? "rtl" : "ltr"}
          initialSlide={Math.floor(frequentlyBoughtTogetherProducts.length / 2)}
          onSlideChange={syncEdges}
          // "auto" makes Swiper measure the rendered slide width instead of
          // deriving it from the container: the stylesheet pins that width, and a
          // numeric slidesPerView computes a different one on narrow viewports,
          // which offsets the centering translate and drifts the active card.
          slidesPerView="auto"
          spaceBetween={20}
          centeredSlides
          className="frequentlyBoughtTogetherProductsSilder"
        >
          {frequentlyBoughtTogetherProducts?.map(({ _source }, key) => (
            <SwiperSlide key={key}>
              <ProductCard
                {...{
                  t,
                  product: _source,
                  isShowCompareBtn: false,
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {swiper?.slides?.length > 2 && (
          <>
            {(locale === "ar" ? !isEnd : !isBeginning) && (
              <button
                onClick={() =>
                  locale === "ar" ? swiper?.slideNext() : swiper?.slidePrev()
                }
                aria-label="Prev Button"
                className="absolute z-50 top-1/2 left-5 w-7 h-7 bg-gray-400/60 rounded-full flex items-center justify-center text-tertiary-600 -translate-y-1/2"
              >
                <ArrowIcon className="text-gray-600 rotate-180 size-3" />
              </button>
            )}
            {(locale === "ar" ? !isBeginning : !isEnd) && (
              <button
                onClick={() =>
                  locale === "ar" ? swiper?.slidePrev() : swiper?.slideNext()
                }
                aria-label="Next Button"
                className="absolute z-50 top-1/2 right-5 w-7 h-7 bg-gray-400/60 rounded-full flex items-center justify-center text-tertiary-600 -translate-y-1/2"
              >
                <ArrowIcon className="text-gray-600 size-3" />
              </button>
            )}
          </>
        )}
      </div>
    </>
  ) : null;
};

export default FrequentlyBoughtTogetherSwiper;
